import { TransferSuccessSnackbarNotistack } from '@mdlbeasts/nofomo.ui.web';
import { Theme, useMediaQuery } from '@mui/material';
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import { ReactNode } from 'react';

import Snackbar from './Snackbar';
import styles from './snackbar.module.css';

interface Props {
  children: ReactNode;
}

declare module 'notistack' {
  interface VariantOverrides {
    seatsTimer: true;
    transferSuccess: true;
  }
}

const SnackbarProvider = ({ children }: Props) => {
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <NotistackSnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: isMobile ? 'top' : 'bottom',
        horizontal: isMobile ? 'center' : 'right',
      }}
      autoHideDuration={3000}
      preventDuplicate
      Components={{
        success: Snackbar,
        warning: Snackbar,
        error: Snackbar,
        info: Snackbar,
        seatsTimer: Snackbar,
        transferSuccess: TransferSuccessSnackbarNotistack,
      }}
      classes={{ containerRoot: styles.snackbarContainer }}
    >
      {children}
    </NotistackSnackbarProvider>
  );
};

export default SnackbarProvider;
